<template>
  <div class="stake">
    <div>
      <div class="header">
        <div class="container">
          <img @click="goHome()" class="logo" src="../assets/logo.png" alt="" />
          <span class="float-right header-height ts-stake">TS Stake</span>
        </div>
      </div>

      <div class="container">
        <p class="instr">
          For TS holders to exchange the TS into USDT. We divided the process
          into two periods, stake period and claim period.
        </p>
        <p class="instr">
          In stake period, you can stake anytime, after you stake, there is a
          frozen time for your stake, 7 days. And after we take a snapshot, you
          cannot unstake it, and it will enter claim period. In claim period,
          your share is the amount you staked as a percentage of the total
          staked amount.
        </p>
        <p class="instr">
          In this period, you can exchange your TS into USDT with the share you
          have, and expired time is 7 days, if you don't claim to exchange in 7
          days, we will regard you as quit. After 7 days of the claim period,
          you can unstake your TS.
        </p>
      </div>

      <div class="body">
        <div :class="['container', isStakingPeriod ? 'active' : '']">
          <h4>Stake period</h4>
          <h2>Stake or Unstake TS</h2>

          <div v-if="currentWallet">
            <div class="col-6">
              <p>
                Your balance:
                <span @click="maxInputStake()"
                  >{{ tsBalance | amountFormat }} TS</span
                >
              </p>
              <p>
                <input type="text" class="stake-amount" v-model="stakeAmount" />
              </p>

              <button
                v-if="!+stakeAmount || +stakeAmount > +tsBalance || submitting"
                class="confirm-btn disabled"
              >
                Stake
              </button>
              <button
                v-else-if="needApprove"
                @click="approveAndStake()"
                :class="['confirm-btn', isStakingPeriod ? '' : 'disabled']"
              >
                Approve and Stake
              </button>
              <button
                v-else
                @click="stake()"
                :class="['confirm-btn', isStakingPeriod ? '' : 'disabled']"
              >
                Stake
              </button>
            </div>

            <div class="col-6">
              <p>
                Your staked:
                <span @click="maxInputUnstake()">
                  {{ yourStakedAmount | amountFormat }} TS
                </span>
                / Total staked: {{ totalStaked | amountFormat }} TS
              </p>
              <p>
                <input
                  type="text"
                  class="stake-amount"
                  v-model="unStakeAmount"
                />
              </p>

              <button
                v-if="!+yourStakedAmount || submitting"
                class="confirm-btn disabled"
              >
                Unstake
              </button>
              <button
                v-else-if="canUnstake"
                @click="unstake()"
                :class="['confirm-btn', isStakingPeriod ? '' : 'disabled']"
              >
                Unstake
              </button>
              <button v-if="!canUnstake" class="confirm-btn disabled">
                Unstake available at
                {{ (+this.yourStakedTime + +this.freezingTime) | timeFormat }}
              </button>
            </div>
          </div>

          <div v-else>
            <button class="confirm-btn" @click="connect()">
              Connect Wallet
            </button>
          </div>
        </div>

        <div :class="['container', !isStakingPeriod ? 'active' : '']">
          <h4>Claim period</h4>
          <h2>Claim Your Share</h2>

          <!-- <p>snapshotBalance : {{ snapshotBalance | amountFormat }}</p>
          <p>exchangeRate: {{ exchangeRate | amountFormat }}</p>
          <p>totalClaimableAmount: {{ totalClaimableAmount | amountFormat }}</p> -->

          <div v-if="currentWallet">
            <p v-if="!isStakingPeriod && !isClaimed">
              <label for="">Your Share:</label>
              {{ yourClaimAmount | amountFormat }}
              {{ claimSymbol }}
            </p>
            <button v-if="submitting" class="confirm-btn disabled">
              Claim
            </button>
            <button
              v-else-if="!isStakingPeriod && !isClaimed"
              @click="claim()"
              class="confirm-btn"
            >
              Claim
            </button>
            <button v-else-if="isStakingPeriod" class="confirm-btn disabled">
              Wait for claim period start
            </button>
            <button v-else-if="isClaimed" class="confirm-btn disabled">
              Claimed
            </button>
          </div>
          <div v-else>
            <button class="confirm-btn" @click="connect()">
              Connect Wallet
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import Web3 from "web3";
import _ from "lodash";
import Big from "big.js";

const TOKEN_ABI = [
  {
    constant: false,
    inputs: [
      {
        name: "_spender",
        type: "address",
      },
      {
        name: "_value",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        name: "",
        type: "bool",
      },
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        name: "_owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        name: "balance",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        name: "_owner",
        type: "address",
      },
      {
        name: "_spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        name: "remaining",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
];

const STAKE_ABI = [
  {
    inputs: [],
    name: "acceptExecutorship",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "freeze",
        type: "uint256",
      },
    ],
    name: "changeFreeze",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "executor",
        type: "address",
      },
      {
        internalType: "address",
        name: "ts",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldFreeze",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newFreeze",
        type: "uint256",
      },
    ],
    name: "ChangeFreeze",
    type: "event",
  },
  {
    inputs: [],
    name: "claim",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "round",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "claimAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "latestAccountStaked",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "latestStakedBalance",
        type: "uint256",
      },
    ],
    name: "Claim",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "uint256",
        name: "latestStaked",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "latestAccountStaked",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "latestStakedBalance",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "latestTime",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "emergencyWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executor",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "EmergencyWithdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousExecutor",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newExecutor",
        type: "address",
      },
    ],
    name: "ExecutorshipTransferStarted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousExecutor",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newExecutor",
        type: "address",
      },
    ],
    name: "ExecutorshipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferStarted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "currentToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256",
      },
    ],
    name: "setupClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "rate",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "snapshot",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "exchangeAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "SetupClaim",
    type: "event",
  },
  {
    inputs: [],
    name: "setupPaused",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "oldPaused",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "newPaused",
        type: "bool",
      },
    ],
    name: "SetupPaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newExecutor",
        type: "address",
      },
    ],
    name: "transferExecutorship",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "latestAccountStaked",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "latestStakedBalance",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
  {
    inputs: [],
    name: "burnAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "stakedAmount_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "snapshot_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "exchangAmount_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "exchangeRate_",
        type: "uint256",
      },
    ],
    name: "calculate",
    outputs: [
      {
        internalType: "uint256",
        name: "thisClaimTS",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "thisClaimToken",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "claimed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "exchangeAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "exchangeRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "exchangeRounds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "executor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "freezeTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingExecutor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "snapshotBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "staked",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stakedBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const BSC_NODE = "https://bsc-dataseed3.defibit.io";

const TS_CONTRACT = "0x91dc92be0bfc47db50790949f423b62282887292";

const STAKE_CONTRACT = "0x12F3f0c40195E3590C5d2930c9714F9d1D145a39";

export default {
  name: "Stake",
  data() {
    return {
      currentWallet: "",
      isStakingPeriod: false,
      claimSymbol: "USDT", // todo
      claimTokenContract: "",
      isClaimed: true,
      web3: null,
      stakeAmount: "",
      unStakeAmount: "",
      freezingTime: 0,
      yourStakedAmount: "",
      yourStakedTime: "",
      approvedAmount: 0,
      tsBalance: "",
      submitting: false,
      events: [],
      address: "",
      addressInfo: "",
      walletAddress: "",
      walletChain: "",
      tokensStr: "",
      hasData: "",
      bscWeb3: "",
      claiming: false,
      totalClaimableAmount: 0,
      exchangeRate: 1,
      snapshotBalance: "",
      totalStaked: "",
    };
  },
  filters: {
    timeFormat: (val) => {
      return dayjs(val * 1000).format("MM-DD HH:mm");
    },
    amountFormat: (val) => {
      if (val) {
        return parseFloat(Math.floor(val * 100) / 100).toFixed(2);
      } else {
        return 0;
      }
    },
  },
  created() {
    this.bscWeb3 = new Web3(BSC_NODE);
    this.connect();
  },
  computed: {
    yourClaimAmount: function () {
      if (
        this.yourStakedAmount &&
        this.snapshotBalance &&
        this.totalClaimableAmount
      ) {
        return _.min([
          this.totalClaimableAmount *
            (this.yourStakedAmount / this.snapshotBalance),
          this.yourStakedAmount * this.exchangeRate,
        ]);
      } else {
        return 0;
      }
    },
    needApprove: function () {
      return (
        this.stakeAmount &&
        +this.stakeAmount > this.approvedAmount / Math.pow(10, 18)
      );
    },
    canUnstake: function () {
      if (this.yourStakedTime) {
        console.log(
          "canUnstake",
          Date.now(),
          this.yourStakedTime,
          this.freezingTime
        );
        return (
          Date.now() > this.yourStakedTime * 1000 + this.freezingTime * 1000
        );
      }
      return false;
    },
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    maxInputStake() {
      this.stakeAmount = this.tsBalance;
    },
    maxInputUnstake() {
      this.unStakeAmount = this.yourStakedAmount;
    },
    async connect() {
      if (!window.ethereum) {
        alert("You need connect you wallet to claim the refund");
        return;
      }

      try {
        let walletAddresses = await ethereum.request({
          method: "eth_requestAccounts",
        });

        if (ethereum.chainId !== "0x38") {
          await ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: "0x38",
                chainName: "BNB Chain",
                rpcUrls: [BSC_NODE],
                nativeCurrency: {
                  name: "Binance Chain Native Token",
                  symbol: "BNB",
                  decimals: 18,
                },
              },
            ],
          });
        }

        this.currentWallet = walletAddresses[0];

        this.web3 = new Web3(window.ethereum);
        this.queryInfo();
      } catch (err) {
        console.log(err);
      }
    },
    queryInfo() {
      if (this.web3) {
        // token
        // ts balance
        let instance = new this.web3.eth.Contract(TOKEN_ABI, TS_CONTRACT);

        instance.methods
          .balanceOf(this.currentWallet)
          .call()
          .then((res) => {
            let bal = new Big(res).div(new Big(Math.pow(10, 18))).toString();
            this.tsBalance = bal;
          });

        // check approve
        instance.methods
          .allowance(this.currentWallet, STAKE_CONTRACT)
          .call()
          .then((res) => {
            this.approvedAmount = res || 0;
            console.log("approve amount", this.approvedAmount);
          });

        // stake contract
        let stakeInstance = new this.web3.eth.Contract(
          STAKE_ABI,
          STAKE_CONTRACT
        );

        // current period
        stakeInstance.methods
          .paused()
          .call()
          .then((res) => {
            this.isStakingPeriod = !!res;
          });

        // staked
        stakeInstance.methods
          .staked(this.currentWallet)
          .call()
          .then((res) => {
            this.yourStakedAmount = new Big(res[0])
              .div(Math.pow(10, 18))
              .toString();
            this.yourStakedTime = res[1];

            console.log(this.yourStakedAmount, this.yourStakedTime);
          });

        // claim token
        stakeInstance.methods
          .token()
          .call()
          .then((res) => {
            console.log("claim token contract", res);
            this.claimTokenContract = res;
          });

        // freezingTime
        stakeInstance.methods
          .freezeTime()
          .call()
          .then((res) => {
            this.freezingTime = res;
          });

        // if claimed
        stakeInstance.methods
          .claimed(this.currentWallet)
          .call()
          .then((res) => {
            this.isClaimed = res;
          });

        // current round claimable token amount
        stakeInstance.methods
          .exchangeAmount()
          .call()
          .then((res) => {
            this.totalClaimableAmount = res ? res / Math.pow(10, 18) : 0;
          });

        // exchangeRate
        stakeInstance.methods
          .exchangeRate()
          .call()
          .then((res) => {
            this.exchangeRate = res / 10000;
          });

        // snapStaked
        stakeInstance.methods
          .snapshotBalance()
          .call()
          .then((res) => {
            this.snapshotBalance = res / Math.pow(10, 18);
          });

        // metric
        // totalStaked
        stakeInstance.methods
          .stakedBalance()
          .call()
          .then((res) => {
            this.totalStaked = res / Math.pow(10, 18);
          });
      }
    },
    approveAndStake() {
      if (this.web3) {
        // approve
        let instance = new this.web3.eth.Contract(TOKEN_ABI, TS_CONTRACT);

        this.submitting = true;

        instance.methods
          .approve(
            STAKE_CONTRACT,
            "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
          )
          .send({ from: this.currentWallet })
          .on("transactionHash", (hash) => {})
          .on("receipt", (receipt) => {
            this.stake();
          })
          .on("error", (err) => {
            this.submitting = false;
            console.log(err);
          });
      }
    },
    unstake() {
      if (this.web3 && this.unStakeAmount && this.isStakingPeriod) {
        let stakeInstance = new this.web3.eth.Contract(
          STAKE_ABI,
          STAKE_CONTRACT
        );

        this.submitting = true;

        let num = new Big(this.unStakeAmount)
          .times(new Big(Math.pow(10, 18)))
          .toFixed(0);

        try {
          stakeInstance.methods
            .withdraw(num)
            .send({ from: this.currentWallet })
            .on("transactionHash", (hash) => {})
            .on("receipt", (receipt) => {
              this.queryInfo();
              this.submitting = false;
            })
            .on("error", (err) => {
              this.submitting = false;
              console.log(err);
            });
        } catch (err) {
          this.submitting = false;
          console.log(err);
        }
      }
    },
    stake() {
      if (this.web3 && this.stakeAmount && this.isStakingPeriod) {
        this.submitting = true;
        let stakeInstance = new this.web3.eth.Contract(
          STAKE_ABI,
          STAKE_CONTRACT
        );

        let num = new Big(this.stakeAmount)
          .times(new Big(Math.pow(10, 18)))
          .toFixed(0);

        try {
          stakeInstance.methods
            .deposit(num)
            .send({ from: this.currentWallet })
            .on("transactionHash", (hash) => {})
            .on("receipt", (receipt) => {
              this.submitting = false;
              this.queryInfo();
            })
            .on("error", (err) => {
              console.log(err);
              this.submitting = false;
            });
        } catch (err) {
          this.submitting = false;
          console.log(err);
        }
      }
    },
    async claim() {
      if (this.web3) {
        this.submitting = true;

        let stakeInstance = new this.web3.eth.Contract(
          STAKE_ABI,
          STAKE_CONTRACT
        );

        try {
          stakeInstance.methods
            .claim()
            .send({ from: this.currentWallet, gasPrice: 3000000000 })
            .on("transactionHash", (hash) => {})
            .on("receipt", (receipt) => {
              this.submitting = false;
              this.queryInfo();
            })
            .on("error", (err) => {
              this.submitting = false;
              console.log(err);
            });
        } catch (err) {
          console.log(err);
          this.submitting = false;
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.tip-error {
  background: #ffecec;
  color: #f56459;
  padding: 12px 24px;
  border-radius: 8px;
  margin-top: 24px !important;
}

.col-6 {
  width: 49%;
  display: inline-block;
}

p {
  margin: 8px 0;
}

.tips {
  color: #ff7114;
  background: #fef5ee;
  border-radius: 8px;
  padding: 6px 12px;
  margin: 12px -4px;

  span {
    display: inline-block;
    vertical-align: middle;
    font-weight: bold;
  }

  .icon-warning {
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-right: 8px;
    background: url("../assets/warning.png") no-repeat;
    background-size: 100% 100%;
  }
}

p.instr {
  font-size: 14px;
}
.tip-warning {
  background: #fef5ee;
  word-break: break-all;
  color: #ff7114;
  padding: 12px 24px;
  border-radius: 8px;
  margin-top: 24px !important;
}

.stake-amount {
  width: 90%;
  max-width: 330px;
  padding: 8px 12px;
  font-size: 16px;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid #e6e8ea;
}

.body {
  text-align: center;

  .container {
    padding: 12px;
    background: #afafaf;
    &.active {
      background: #fff;
      box-shadow: 0 0 8px 0px #999;
    }

    h4 {
      text-align: left;
      margin: 12px;
    }
  }

  .loading {
    text-align: center;
    line-height: 200px;
    font-size: 16px;
  }

  .data-address {
    word-break: break-all;
  }

  ul {
    li {
      margin: 8px 0;
    }
  }

  .result-content {
    text-align: left;
    width: 90%;
    max-width: 900px;
    border: 1px solid #e6e8ea;
    border-radius: 16px;
    margin: 24px auto;
    min-height: 200px;
    padding: 24px 32px;
    box-sizing: border-box;

    div {
      margin: 12px 0;
    }

    label {
      display: inline-block;
      vertical-align: middle;
      min-width: 142px;
      color: #9ea0a5;
    }
  }

  .have-question {
    text-align: left;
    width: 90%;
    max-width: 900px;
    // border: 1px solid #e6e8ea;
    border-radius: 16px;
    margin: 24px auto;
    min-height: 200px;
    padding: 24px;
    box-sizing: border-box;

    ul {
      margin: 18px 0;
    }

    li {
      margin: 8px 0;
    }

    h5 {
      margin: 12px 0 8px;
    }

    .other-reason,
    .email {
      max-width: 680px;
      width: 90%;
      border-radius: 8px;
      padding: 10px 16px;
      font-size: 16px;
      border: 2px solid #e6e8ea;
      box-sizing: border-box;
    }
  }

  .self-check {
  }

  .confirm-btn {
    width: 90%;
    max-width: 340px;
    margin: 12px auto;
    padding: 14px;
    background: #3772ff;
    // background: #ddd;
    border: none;
    border-radius: 90px;
    font-weight: bold;
    font-size: 16px;
    color: #fff;

    &.btn-sm {
      width: auto;
      padding: 4px 8px;
      margin: 0;
      margin-left: 8px;
      font-size: 13px;
    }

    &.disabled {
      background: #ddd;
    }
  }

  h2 {
    font-size: 38px;
    margin: 10px 0;
    color: #3a3b3d;
  }
}

@media screen and (max-width: 460px) {
  p.instr {
    padding: 0 12px;
    line-height: 1.2;
    font-size: 12px;
  }

  .col-6 {
    width: 90%;
    display: block;
    margin: 12px 0;
  }
  .body {
    h2 {
      font-size: 24px;
    }
    .confirm-btn {
      padding: 12px;
      font-size: 16px;
    }
  }
}
</style>
